<template>
    <div>
        <v-data-table :headers="headers" :items="dispositivos" disable-pagination hide-default-footer>
            <template v-slot:[`item.rdi_so`]="{ item }">
                <v-icon :title="tituloPlataforma(item)" :color="corIconePlataforma(item)">{{
                    iconePlataforma(item)
                    }}</v-icon>
                    {{ item.rdi_so_versao }}
            </template>
            <template v-slot:[`item.rdi_ultimo_acesso`]="{ item }">
                {{ item.rdi_ultimo_usuario }}<br />
                {{ item.rdi_ultimo_acesso }}
            </template>
            <template v-slot:[`item.opcao`]="{ item }">
                <span>
                    <v-btn v-if="!item.rdi_inativo" small rounded color="error" @click="alterarStatus(item)">
                        <v-icon>block</v-icon>Desativar
                    </v-btn>
                    <v-btn v-if="item.rdi_inativo" small rounded color="success" title="Desativar"
                        @click="alterarStatus(item)">
                        <v-icon>check</v-icon>Ativar
                    </v-btn>
                </span>
            </template>
        </v-data-table>
    </div>
</template>
<script>
export default {
    props: ['dispositivos'],
    data: () => ({
        headers: [
            { text: 'ID', value: 'rdi_seqinterna' },
            { text: 'UUID', value: 'rdi_dispositivo_uuid' },
            { text: 'Modelo', value: 'rdi_modelo' },
            { text: 'Plataforma', value: 'rdi_so', align: 'center', sortable: false },
            { text: 'V. APP', value: 'rdi_app_versao', align: 'end', sortable: false },
            // { text: 'Último ', value: 'rdi_ultimo_usuario' },
            { text: 'Acesso App', value: 'rdi_ultimo_acesso', sortable: false },
            { text: '', align: 'center', value: 'opcao', sortable: false }
        ]
    }),
    methods: {
        tituloPlataforma(item) {
            if (item.rdi_so == 'iOS') return 'iOS'
            if (item.rdi_so == 'Android') return 'Android'
            return ''
        },
        iconePlataforma(item) {
            if (item.rdi_so == 'iOS') return 'mdi-apple'
            if (item.rdi_so == 'Android') return 'android'
            return 'help'
        },
        corIconePlataforma(item) {
            if (item.rdi_so == 'iOS') return 'grey lighten-1'
            if (item.rdi_so == 'Android') return 'green'
            return 'blue'
        },
        async alterarStatus(item) {
            try {
                const response = await this.axios.put(
                    `/rdispositivos/${item.rdi_seqinterna}/rdi_inativo`,
                    { rdi_inativo: !item.rdi_inativo },
                )

                if (response.status == 204) {
                    this.$store.dispatch('showSuccess', 'Status do dispositivo alterado com sucesso!')
                    this.$emit('dispositivosChanged')

                } else {
                    this.$store.dispatch('showError', response.data.mensagem)
                }
            } catch (error) {
                this.$store.dispatch('showError', error)
            }
        },
        // async alterarFBApiKey(item) {
        //     try {
        //         const response = await this.axios.put('/api/dispositivos/fbapikey', {
        //             token: item.emp_chavedispositivo,
        //             uuid: item.dis_uuid,
        //             Fb_api_key: ''
        //         })

        //         if (response.data.valido) {
        //             this.$store.dispatch(
        //                 'showSuccess',
        //                 'Chave de notificações redefinida, será necessário abrir o app novamente'
        //             )
        //             this.$emit('dispositivosChanged')
        //         } else {
        //             this.$store.dispatch('showError', response.data.mensagem)
        //         }
        //     } catch (error) {
        //         this.$store.dispatch('showError', error)
        //     }
        // },
        async enviaNotificacaoTeste(item) {
            try {
                let date = new Date().toLocaleDateString()
                let time = new Date().toLocaleTimeString()

                const response = await this.axios.post(
                    `/notificacao/${item.id}/teste`,
                    { date, time },
                    { baseURL: 'https://api.notifica.sicplug.com.br' }
                )

                this.$store.dispatch(response.data.valido ? 'showSuccess' : 'showError', response.data.msg)
            } catch (error) {
                this.$store.dispatch('showError', error)
            }
        }
    }
}
</script>
